import {formatBedrooms} from "./formatBedrooms";

export const formatBedsRange = (min?: number | null, max?: number | null): string => {
  if (typeof min === "number" && typeof max === "number") {
    if (min === max) {
      return `${formatBedrooms(min)}`;
    } else {
      return `${formatBedrooms(min)}–${formatBedrooms(max)}`;
    }
  } else if (typeof max === "number") {
    return `Max: ${formatBedrooms(max)}`;
  } else if (typeof min === "number") {
    return `${formatBedrooms(min)}+`;
  }
  return "Bedrooms";
};
